import { Component, ContentChild, Input, TemplateRef } from '@angular/core';
import { IListLoopingConfig } from './models/list-looping.config.model';

@Component({
  selector: 'app-tqw-list-looping',
  templateUrl: './tqw-list-looping.component.html',
  styleUrls: ['./tqw-list-looping.component.scss']
})
export class TqwListLoopingComponent  {

  @ContentChild(TemplateRef) listItem!: TemplateRef<unknown>;
  @Input() config!: IListLoopingConfig;

}
